export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uživatel nenalezen"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vybrat"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zavřít"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhledávání"])}
}